<template>
  <v-card class="link-preview mb-4" elevation="1">
    <v-row align-content="center" no-gutters>
      <v-col cols="auto" align-self="center" class="pa-4 pt-2 pb-2 pr-0">
        <v-img max-width="106" max-height="80" :src="image()"></v-img>
      </v-col>
      <v-col cols class="pa-4">
        <p class="body-1 ma-0">
          {{ previewObject.title }}
        </p>
        <p class="body-2 font-weight-light ma-0 ellipsis">
          {{ previewObject.description.substring(0, 50) }}
        </p>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  props: ["previewObject"],
  methods: {
    image() {
      if (this.previewObject) {
        if (this.previewObject.image) {
          return this.previewObject.image;
        } else if (this.previewObject.images) {
          return this.previewObject.images[0];
        }
      }
    },
  },
};
</script>
